<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Assessment Result</h2>
    </div>
    <div class="intro-y col-span-12 flex flex-wrap items-center gap-y-2">
      <button
        class="button text-white shadow-md mr-2 "
        @click="showAll()"
        :class="{
          'bg-theme-10': selectedJob == 'all',
          'bg-theme-27': selectedJob != 'all',
        }"
      >
        All
      </button>
      <button
        class="button text-white shadow-md mr-2"
        v-for="j in jobs"
        :key="j"
        @click="filterByJob(j)"
        :class="{
          'bg-theme-10': selectedJob == j,
          'bg-theme-27': selectedJob != j,
        }"
      >
        {{ j }}
      </button>
      <div class="hidden md:block mx-auto text-gray-600">
        Showing {{ list.length }} entries
      </div>
    </div>
    <div
      class="col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"
      style="position: sticky; top: 0px; background-color: #F1F5F8;"
    >
      <div style="display: flex; width: 50%;">
        <button class="mr-5 text-blue-700" style="font-weight: 800">
          Rounds:
        </button>
        <button
          class="button text-white bg-blue-600 shadow-md mr-10 my-5"
          @click="setRound('all')"
        >
          Undo
        </button>
        <button
          class="button text-white shadow-md mr-10 my-5"
          v-for="r in rounds"
          :key="r"
          @click="setRound(r)"
          :class="{ 'bg-theme-32': round == r, 'bg-theme-15': round != r }"
        >
          Round {{ r }}
        </button>
      </div>
      <div style="display: flex; justify-content: end; width: 50%;">
        <button
          class="button text-white shadow-md ml-10 my-5 bg-blue-600"
          @click="sendEmail()"
        >
          Send Email
        </button>
        <button
          class="button text-white shadow-md ml-10 my-5 bg-green-600"
          @click="promote()"
        >
          Promote to Next Round
        </button>
      </div>
    </div>
    <div class="flex flex-col">
      <vue-json-to-csv
        class="mb-6"
        :json-data="list"
        :labels="{
          name: { title: 'Name' },
          email: { title: 'Email' },
          phone: { title: 'Phone' },
          cv: { title: 'CV' },
          linkedin: { title: 'LinkedIn' },
          score: { title: 'Score' },
        }"
        csv-title="data"
      >
        <button class="button bg-green-800 text-white mt-2 shadow-md mr-2">
          <b>Download data</b>
        </button>
      </vue-json-to-csv>
    </div>
    <div class="overflow-x-auto">
      <table class="table">
        <thead>
          <tr>
            <th
              class="border border-b-2 dark:border-dark-5 whitespace-no-wrap"
            ></th>
            <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap">
              #
            </th>
            <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap">
              Name
            </th>
            <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap">
              Phone
            </th>
            <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap">
              Email
            </th>
            <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap">
              LinkedIn
            </th>
            <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap">
              CV
            </th>
            <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap">
              Report
            </th>
            <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap">
              Score
            </th>
            <th class="border border-b-2 dark:border-dark-5 whitespace-no-wrap">
              Job
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="hover:bg-gray-200 odd:bg-blue-100 bg-white"
            v-for="(d, i) in list"
            :key="d.id"
          >
            <td class="border">
              <input type="checkbox" v-model="d.selected" />
            </td>
            <td class="border">{{ i + 1 }}</td>
            <td class="border font-bold">{{ d.name }}</td>
            <td class="border">{{ d.phone }}</td>
            <td class="border">
              <a :href="`mailto:${d.email}`">{{ d.email }}</a>
            </td>
            <td class="border">
              <a
                :href="d.linkedin.startsWith('http') ? d.linkedin : d.linkedin"
                target="_blank"
                >{{ d.linkedin }}</a
              >
            </td>
            <td class="border font-bold">
              <a :href="`${d.cv}`" target="_blank">CV FILE</a>
            </td>
            <td class="border">
              <a
                :href="`https://quiz.upskill.com.bd/report/${d.session}`"
                target="_blank"
                >Click here</a
              >
            </td>
            <td class="border">{{ d.score }}</td>
            <td class="border">{{ d.job }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueJsonToCsv from 'vue-json-to-csv'
import Button from '@/views/Button'
import Icon from '@/views/Icon'

export default {
  data() {
    return {
      list: [],
      round: '1',
      rounds: ['1', '2'],
      jobs: [],
      originalList: [],
      selectedJob: '',
      temp: [],
    }
  },
  components: {
    Icon,
    Button,
    VueJsonToCsv,
  },
  methods: {
    setRound(r) {
      if (r == 'all') {
        this.list = [...this.temp]
        return
      }
      this.temp = [...this.list]
      this.round = r
      this.list = this.list.filter((o) => o.round == r)
    },
    sendEmail() {
      let list = this.list.filter((o) => o.selected)
      let emailStr = ''
      list.forEach((o) => {
        emailStr += o.email + ','
      })
      console.log(emailStr)
      let body = `Congratulations! You have been selected for the next round!`
      window.open(
        `mailto:${emailStr}?subject="Congratulations! You have been promoted to Round 2!&body=${body}`
      )
    },
    promote() {
      this.temp = { ...this.list }
      let list = this.list.filter((o) => o.selected)
      list.forEach((o) => {
        o.round = '2'
      })
      this.setRound('2')
    },
    getList() {
      axios
        .get('https://service6.upskill.com.bd/api/apps/assessment')
        .then((res) => {
          let list = res.data.data || []
          let filtered = list.filter((o) => o.cv.startsWith('assessment'))
          this.list = filtered
          this.list.forEach((o) => {
            o.cv =
              `https://upskill-files.s3.ap-southeast-1.amazonaws.com/` + o.cv
          })
          this.list.sort((a, b) => parseInt(b.score) - parseInt(a.score))
          this.originalList = [...this.list]
          this.getHash()
        })
    },
    getHash() {
      let hash = {}
      this.list.forEach((o) => {
        hash[o.job] = true
      })
      this.jobs = Object.keys(hash)
    },
    showAll() {
      this.selectJob('all')
      this.list = [...this.originalList]
      this.list.forEach((o) => (o.round = '1'))
    },
    filterByJob(job) {
      this.selectJob(job)
      this.list = this.originalList.filter((o) => o.job == job)
    },
    selectJob(job) {
      this.selectedJob = job
    },
  },
  created() {
    this.getList()
  },
}
</script>
